import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

const services = [
  {
    icon: "ri-bar-chart-box-line",
    title: "WEB広告運用",
    description:
      "媒体選定、配信設計、入札・予算調整、モニタリングと改善までを一貫して行い、広告成果の最大化を支援します。",
  },
  {
    icon: "ri-image-edit-line",
    title: "広告クリエイティブ制作・改善",
    description:
      "訴求仮説の立案、静止画・動画・コピーの制作と改善を継続的に検証し、成果につながる表現を追求します。",
  },
  {
    icon: "ri-pages-line",
    title: "LP・計測環境改善",
    description:
      "LPの構成・導線の改善、タグ・コンバージョン計測の整備を通じて、広告との一貫性を保った獲得効率の向上を目指します。",
  },
  {
    icon: "ri-compass-3-line",
    title: "マーケティング戦略支援",
    description:
      "KPI・評価基準の設計、顧客・競合・訴求の整理、施策ロードマップの策定など、事業成果につなげる戦略立案を支援します。",
  },
];

export default function Services() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section
      id="services"
      ref={ref}
      className="relative py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-20"
    >
      <div className="max-w-6xl mx-auto">
        <div
          className={`section-animate ${isVisible ? "visible" : ""} text-center mb-16 md:mb-20`}
        >
          <p className="text-xs md:text-sm tracking-[0.3em] text-text-muted mb-2">
            SERVICE
          </p>
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight text-white">
            事業内容
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div
              key={service.title}
              className={`section-animate ${
                isVisible ? "visible" : ""
              } group relative p-6 md:p-8 border border-border/60 hover:border-accent/40 bg-surface/40 hover:bg-surface/80 transition-all duration-500`}
              style={{
                transitionDelay: isVisible
                  ? `${0.1 * (index + 1)}s`
                  : "0s",
              }}
            >
              <div className="w-12 h-12 flex items-center justify-center mb-5 md:mb-6">
                <i
                  className={`${service.icon} text-xl md:text-2xl text-accent`}
                />
              </div>

              <h3 className="text-base md:text-lg font-bold text-white mb-3 md:mb-4 tracking-tight">
                {service.title}
              </h3>

              <p className="text-xs md:text-sm text-text-secondary leading-relaxed">
                {service.description}
              </p>

              <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-accent/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}